import Chat, { Bubble, useMessages } from '@chatui/core';
import '@chatui/core/dist/index.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import { AppContext } from '../../../../contexts/AppContext';
import APIList from '../../../../http/ApiList';
import { Button, Checkbox, Form, Mentions } from 'antd';
import UnlimitedComponentContainer from './unlimited-component-container';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import TextArea from 'antd/es/input/TextArea';
import { websocketConnection } from '../../../../http/common/websocket';
import { cloneDeep } from 'lodash';

const UnlimitedChatContainer: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const { messages, appendMsg, setTyping, updateMsg, resetList } = useMessages([]);
  const [chatList, setChatList] = useState<any>([]);
  const [roleList, setRoleList] = useState<any>([]);
  const [checkedRoleList, setCheckedRoleList] = useState<any>([]);
  const [chatContent, setChatContent] = useState<any>({});
  const [chatId, setChatId] = useState<any>(null);
  const [form] = Form.useForm();
  const [editBubble, setEditBubble] = useState<any>({});
  const [editConversation, setEditConversation] = useState<any>({ value: '' });
  const [mentionValue, setMentionValue] = useState<any>({ value: '' });
  const [promptData, setPromptData] = useState(null);
  const mentionsRef = useRef(null);
  const ref: any = useRef(null);
  const [contianerWidth, setContianerWidth] = useState(1200);
  const [components, setComponents] = useState<any>({});

  const configuration = {
    avatar: process.env.REACT_APP_DOMAIN + 'assets/counsel-gpt.png',
  };
  const openaiConfig = process.env;

  const chatDragWidth = 600;

  const chatDragTop = 50;
  let chatDragLeft = 0;
  let chatDragBottom = 0;
  let chatDragHeight = 820;

  if (typeof window !== 'undefined') {
    chatDragHeight = document.body.clientHeight - 200;
    chatDragLeft = document.body.clientWidth - chatDragWidth;
    chatDragBottom = document.body.clientHeight - chatDragTop - chatDragHeight;
  }

  const getChatData = (event: any) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setChatList(res.data);
      });
  };

  const getComponents = (type, data?: any) => {
    const items = [];
    switch (type) {
      case 'Top5':
        items.push({
          name: 'news',
          w: 24,
          h: 12,
          padding: '',
          margin: '',
          type: 'news',
          dataSource: {
            mockData:
              '[\r\n    {\r\n        "title": "財務の安定性・リスク管理",\r\n        "contentText": "日揮の大型案件における独自モジュール化工法（J・I・ModuleTM工法）や実績の財務がパナンスの具体的な訴求に対する、東洋エンジニアリングの財務マネジメント・リスクマネジメントの具体性の欠如の指摘"\r\n    },\r\n    {\r\n        "title": "成長戦略の具体性と多様性",\r\n        "contentText": "東洋エンジニアリングは主にEPC事業に依存しており、新規事業の開拓やビジネスモデルの多様化については限られた記載しかありません。一方、日揮グループは、 中期経営計画 「BSP2025」でEPC事業の深化だけでなく、高機能材製造事業やサステナブルンリューションズ分野の拡大を積極的に進めています。また、新たな成長エンジンとして水素、アンモニア、SAF (持続可能な航空燃料)などの新興分野にも投資を行っており、これが投資家にとって将来的な収益源の多様化として魅力的に映るでしょう。東洋エンジニアリングの成長戦略の具体本性と多様性の欠如は、長期的な成長を期待する投資家にとって弱点なります。"\r\n    },\r\n    {\r\n        "title": "サステナビリティへの取り組み",\r\n        "contentText": "日揮の具体的なESG戦略および目標値設定に対する東洋エンジニアリングのKPIや達成員標の具体性·記述の欠如に対する指摘"\r\n    },\r\n    {\r\n        "title": "人的資本・組織柔軟性への対応",\r\n        "contentText": "日揮の&D推進やジョプ型人事制度の導入などの具体的な施策に対し、東洋エンジニアリングの施策はスキルアップ等に避定されている指摘"\r\n    },\r\n    {\r\n        "title": "グローバル展開・市場対応力",\r\n        "contentText": "日揮のエネルギーインフラを基軸にした全方位的なグローバル業開に対し、、東洋エンジニアリングは特定地域に特化している差分の指摘"\r\n    }\r\n]',
            api: {
              url: '',
              mockLogic: '',
            },
            triggerEvent: [
              {
                event: 'PAGE_INIT',
              },
            ],
          },
          tag: 'container',
          i: 'a',
          x: 0,
          y: 0,
          show_dataSource: false,
          copyFrom: 'ReportContainer',
        });
        break;
      case 'Strategic Options Summary':
        items.push({
          // name: 'image',
          // w: 8,
          // h: 10,
          x: 0,
          y: 0,
          // padding: '',
          // margin: '',
          // type: 'image',
          // backgroundPosition: 'center center',
          // imageUrl: '/assets/gai/1.png',
          // tag: 'image',

          name: 'StrategicOptionsListContainer',
          w: 28,
          h: 18,
          padding: '',
          margin: '',
          type: 'StrategicOptionsListContainer',
          backgroundImageUrl: '/assets/gai/bg.png',
          dataSource: {
            mockData: '',
            api: {
              url: '/test',
              mockLogic: '()=>{return null}',
            },
          },
          // component: <StrategicOptionsListContainer />,
          i: 'b',
        });
        items.push({
          name: 'image',
          w: 8,
          h: 12,
          x: 0,
          y: 0,
          padding: '',
          margin: '',
          type: 'image',
          backgroundPosition: 'center center',
          imageUrl: '/assets/gai/2.png',
          tag: 'image',
          i: 'c',
        });
        break;
      case 'xxx Chart':
        items.push({
          name: 'image',
          w: 8,
          h: 12,
          x: 0,
          y: 0,
          padding: '',
          margin: '',
          type: 'image',
          backgroundPosition: 'center center',
          imageUrl: '/assets/gai/2.png',
          tag: 'image',
          i: 'c',
        });
        break;
      case 'PPT':
        items.push({
          name: 'image',
          w: 4,
          h: 2,
          x: 0,
          y: 0,
          padding: '',
          margin: '',
          type: 'image',
          backgroundPosition: 'center center',
          imageUrl: '/assets/gai/3.png',
          tag: 'image',
          i: 'd',
        });
        break;
      case 'chart':
        items.push({
          i: 'chart_1728551599091',
          x: 0,
          y: 9,
          w: 7,
          h: 9,
          type: 'chart',
          chartOptions: {
            options: JSON.stringify({
              tooltip: {
                trigger: 'axis',
                appendToBody: true,
                className: 'overflow-all',
                hideDelay: 0,
              },
              legend: { type: 'scroll', top: 0 },
              xAxis: { type: 'category' },
              yAxis: { type: 'value' },
              series: [
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
                { type: 'line', lineStyle: { width: 3 }, symbolSize: 8 },
              ],
            }),
          },
          dataSource: {
            mockData:
              '[["ライン","Aライン","Cライン","Dライン","Fライン","Sライン"],["23F Q1",0.548,0.955,0.769,0.493,0.153],["23F Q2",0.54,0.96,0.77,0.5,0.12],["23F Q3",0.55,0.9,0.78,0.55,0.11],["23F Q4",0.6,0.92,0.78,0.6,0.1],["24F Q1",0.6,0.93,0.76,0.65,0.95]]',
            triggerEvent: [{ event: 'PAGE_INIT' }, { event: 'MENU_ITEM_CLICK' }, { event: 'CHAT_UPDATE' }],
          },
        });
        break;
      case 'chart-data':
        if (data && data.options && data.dataset) {
          items.push({
            i: 'chart_1728551599091',
            x: 0,
            y: 9,
            w: 7,
            h: 9,
            type: 'chart',
            chartOptions: {
              options: JSON.stringify({
                ...data.options,
                ...{
                  tooltip: {
                    trigger: 'axis',
                    appendToBody: true,
                    className: 'overflow-all',
                    hideDelay: 0,
                  },
                  legend: { type: 'scroll', top: 0 },
                },
              }),
            },
            dataSource: {
              mockData: data.dataset,
              triggerEvent: [{ event: 'PAGE_INIT' }, { event: 'MENU_ITEM_CLICK' }, { event: 'CHAT_UPDATE' }],
            },
          });
        }
        break;
      default:
        break;
    }
    return items;
  };

  const getPromptData = () => {
    APIList.getPromptData()
      .get({ email: authInfo?.user?.attributes?.email || '' })
      .then((res: any) => {
        if (!res.data || res.data.length === 0) {
          return;
        }
        const messageMapping = {};
        const eventMapping = {};
        const shortCuts = [];

        res.data.forEach((item) => {
          shortCuts.push(item['キーワード']);
          messageMapping[`${item['キーワード']}_${item['参加者']}`] = item['プロンプト'];
          eventMapping[`${item['キーワード']}_${item['参加者']}`] = {
            eventType: item['イベントタイプ'],
            event: item['イベント'],
          };
        });

        setPromptData({
          shortCuts,
          eventMapping,
          messageMapping,
        });
      });
  };

  useEffect(() => {
    getPromptData();
    const contianerWidth = document.querySelector('.unlimited-chat-container').clientWidth;
    setContianerWidth(contianerWidth - 150);
  }, []);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      property.dataSource &&
      property.dataSource.triggerEvent &&
      property.dataSource.triggerEvent.find((triggerEvent) => {
        return triggerEvent.event === globalEvent.eventType;
      })
    ) {
      if (globalEvent.data) {
        setRoleList(globalEvent.data.roles);
        setChatId(globalEvent.data.key);
        setCheckedRoleList(globalEvent.data.roles);
        getChatData(globalEvent);
        setChatContent({});
        form.resetFields();
      }
    }
    if (globalEvent.eventType === 'CHAT_REMOVED' && globalEvent.data) {
      localStorage.removeItem('chatContent_' + globalEvent.data);
      setRoleList([]);
      setChatId(null);
      setCheckedRoleList([]);
      setChatContent({});
      form.resetFields();
    }
  }, [globalEvent]);

  useEffect(() => {
    if (!chatList) {
      return;
    }
    const messageList = [];
    for (let index = 0; index < chatList.length; index++) {
      const element = chatList[index];
      const content: any = {
        _id: element.key,
        type: 'text',
      };
      if (element.role === 'user') {
        content.position = 'right';
        content.content = { text: element.chat };
      } else {
        content.user = {
          avatar: configuration.avatar,
          name: element.name,
        };
        content.content = {
          text: <Markdown>{element.chat}</Markdown>,
        };
      }
      messageList.push(content);
      if (element.event && element.event.eventType === 'FEEDBACK') {
        messageList.push({
          type: 'feedback',
          content: {
            text: <UnlimitedComponentContainer width={contianerWidth} components={getComponents(element.event.event)} />,
          },
          user: {
            avatar: configuration.avatar,
          },
        });
      }
    }
    resetList(messageList);
    setTimeout(() => {
      if (ref && ref.current) {
        const element = ref.current.getElementsByClassName('PullToRefresh')[0];
        element.scrollTo({
          top: element.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
      }
    }, 500);
  }, [chatList]);

  // useEffect(() => {
  //   updateMsg(msgId, {
  //     type: 'text',
  //     content: {
  //       text: <UnlimitedComponentContainer width={contianerWidth} components={components[newMsgId]} />,
  //     },
  //     user: {
  //       avatar: configuration.avatar,
  //       name: role,
  //     },
  //   });
  // }, [components]);

  const getRandomString = () => {
    const x = 2147483648;
    return Math.floor(Math.random() * x).toString(36) + Math.abs(Math.floor(Math.random() * x) ^ Date.now()).toString(36);
  };

  const storeMessage = (msgId, name, message, role, event?: any) => {
    let chatHistories = [];
    const chatContent = localStorage.getItem('chatContent_' + chatId);
    if (chatContent) {
      chatHistories = JSON.parse(chatContent);
    }
    chatHistories.push({ key: msgId, name, role: role, chat: message, event });
    localStorage.setItem('chatContent_' + chatId, JSON.stringify(chatHistories));
  };

  const handleFeedback = (event) => {
    const newMsgId = getRandomString();

    appendMsg({
      _id: newMsgId,
      type: 'feedback',
      content: {
        text: <UnlimitedComponentContainer width={contianerWidth} components={getComponents(event)} />,
      },
      user: {
        avatar: configuration.avatar,
      },
    });

    setTimeout(() => {
      if (ref && ref.current) {
        const element = ref.current.getElementsByClassName('PullToRefresh')[0];
        element.scrollTo({
          top: element.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
      }
    }, 800);

    setGlobalEvent({ eventType: GLOBAL_EVENT.SHOW_CHAT_CONTENT });
  };

  // const websocketConnection = (msgId, message, role, event?: any) => {
  //   let content = '';
  //   let finished = false;
  //   const onMessageBack = (newMsg: string) => {
  //     if (newMsg === '[Done]') {
  //       finished = true;
  //       storeMessage(msgId, role, content, 'feedback', event);
  //       if (event && event.eventType === 'FEEDBACK') {
  //         handleFeedback(event.event);
  //       }
  //     } else {
  //       content += newMsg;
  //     }

  //     const dom = <Markdown>{content}</Markdown>;

  //     updateMsg(msgId, {
  //       type: 'text',
  //       content: {
  //         text: (
  //           <>
  //             {dom}
  //             {finished ? <></> : <span className="typed"> </span>}
  //           </>
  //         ),
  //       },
  //       user: {
  //         avatar: configuration.avatar,
  //         name: role,
  //       },
  //     });
  //   };

  //   const websocket = new WebSocket(openaiConfig.REACT_APP_WSS_END_POINT);

  //   websocket.onopen = () => {
  //     websocket.send(
  //       JSON.stringify({
  //         action: 'WebsocketOpenaiEvent',
  //         data: { message },
  //       })
  //     );
  //   };

  //   websocket.onmessage = async (e) => {
  //     const data = JSON.parse(e.data);
  //     if (data.status === 200) {
  //       onMessageBack(data.response.message);
  //       websocket.close();
  //     } else if (data.message === 'Internal server error' || data.message === 'Endpoint request timed out') {
  //       // 未解决 先忽略
  //     } else {
  //       websocket.close();
  //     }
  //   };

  //   websocket.onerror = (e: any) => {
  //     console.log('通信失敗: ' + JSON.stringify(e));
  //     websocket.close();
  //     appendMsg({
  //       type: 'text',
  //       content: { text: t('chatgpt.error') },
  //       user: {
  //         avatar: configuration.avatar,
  //         name: role,
  //       },
  //     });
  //   };
  // };

  const parseMessage = (message) => {
    let roles = checkedRoleList;

    // 检查用户列表是否包含某个用户
    // function isUserInList(username) {
    //   return roleList.includes(username);
    // }

    // 提取用户名和对话内容
    // const extractMentions = (message) => {
    //   const mentions = [];
    //   let regex = /@([\w\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]+)/g;
    //   let match;
    //   let newMsg = message;
    //   while ((match = regex.exec(message)) !== null) {
    //     const username = match[1];
    //     if (isUserInList(username)) {
    //       mentions.push(username);
    //       newMsg = newMsg.replace(`@${username}`, '');
    //     }
    //   }
    //   return { mentions, message: newMsg.trim() };
    // };
    // const result = extractMentions(message);

    // const validMentions = result.mentions;
    // 场景1: 没有@ 或者@的人不在列表中
    // if (!/@[\w\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]+/.test(message) || validMentions.length === 0) {
    if (roles.length === 0) {
      const newMsgId = getRandomString();
      // components[newMsgId] = [];
      // setComponents(cloneDeep(components));
      appendMsg({
        _id: newMsgId,
        type: 'typing',
        user: {
          avatar: configuration.avatar,
          name: 'AI Consultant',
        },
      });
      websocketConnection(chatId, newMsgId, message, (layouts) => {
        // components[newMsgId] = layouts;
        // setComponents(cloneDeep(components));
        updateMsg(newMsgId, {
          type: 'text',
          content: {
            text: <UnlimitedComponentContainer width={contianerWidth} components={layouts} />,
          },
          user: {
            avatar: configuration.avatar,
            name: 'AI Consultant',
          },
        });
      });
      // websocketConnection(msgId, message, 'AI Consultant', { eventType: 'FEEDBACK', event: 'chart' });
    } else {
      // 给所有人发送
      for (let index = 0; index < roles.length; index++) {
        const msgId = getRandomString();
        components[msgId] = [];
        setComponents(cloneDeep(components));
        appendMsg({
          _id: msgId,
          type: 'typing',
          content: {
            text: <UnlimitedComponentContainer width={contianerWidth} components={components[msgId]} />,
          },
          user: {
            avatar: configuration.avatar,
            name: roles[index],
          },
        });
        let newMessage = `你作为企业的 ${roles[index]}，请以你专业的角度分析下面的问题： ${message}。请以日语回答。`;
        let event = undefined;
        for (let i = 0; i < promptData.shortCuts.length; i++) {
          const shortCut = promptData.shortCuts[i];
          if (message.includes(shortCut) || message.toLowerCase().includes(shortCut)) {
            const mapping = promptData.messageMapping[`${shortCut}_${roles[index]}`];
            if (mapping) {
              newMessage = mapping;
              event = promptData.eventMapping[`${shortCut}_${roles[index]}`];
              break;
            }
          }
        }
        websocketConnection(chatId, msgId, newMessage, (layouts) => {
          components[msgId] = layouts;
          setComponents(cloneDeep(components));
        });
        // websocketConnection(msgId, newMessage, roles[index], event);
      }
    }
    // } else {
    //   // 提取所有 @ 提及的用户和对话内容
    //   roles = validMentions;

    //   for (let index = 0; index < roles.length; index++) {
    //     const msgId = getRandomString();
    //     appendMsg({
    //       _id: msgId,
    //       type: 'typing',
    //       user: {
    //         avatar: configuration.avatar,
    //         name: roles[index],
    //       },
    //     });
    //     let newMessage = `你作为企业的 ${roles[index]}，请以你专业的角度分析下面的问题： ${result.message}。请以日语回答。`;
    //     let event = undefined;
    //     for (let i = 0; i < promptData.shortCuts.length; i++) {
    //       const shortCut = promptData.shortCuts[i];
    //       if (result.message.includes(shortCut) || result.message.toLowerCase().includes(shortCut)) {
    //         const mapping = promptData.messageMapping[`${shortCut}_${roles[index]}`];
    //         if (mapping) {
    //           newMessage = mapping;
    //           event = promptData.eventMapping[`${shortCut}_${roles[index]}`];
    //           break;
    //         }
    //       }
    //     }
    //     websocketConnection(msgId, newMessage, roles[index], event);
    //   }
    // }
  };

  const sendMessage = (val: string) => {
    setTimeout(() => {
      const eventInfo = {
        eventType: 'MESSAGE_UPDATE',
        data: { key: chatId },
      };
      setGlobalEvent(eventInfo);
    }, 500);

    parseMessage(val);
  };

  const handleSend = (type: string, val: string) => {
    if (type === 'text' && val.trim()) {
      const msgId = getRandomString();
      appendMsg({
        _id: msgId,
        type: 'text',
        content: {
          text: val,
        },
        position: 'right',
      });
      setTyping(true);
      sendMessage(val);
      storeMessage(msgId, 'user', val, 'user');
    }
  };

  const renderMessageContent = (msg: any) => {
    const { content, type, position, _id } = msg;
    if (position === 'right') {
      return (
        <>
          {content.text !== editBubble.text ? (
            <div style={{ position: 'relative', marginBottom: '1.5em' }}>
              <Bubble id={_id || content.text} content={<span>{content.text}</span>} />
              <span style={{ position: 'absolute', right: 0 }}>
                <Button
                  color="primary"
                  type="link"
                  onClick={() => {
                    setEditBubble(content);
                  }}
                >
                  edit
                </Button>
              </span>
            </div>
          ) : (
            <div style={{ width: '100%' }}>
              <TextArea
                style={{ width: '100%', position: 'relative', marginBottom: '2em' }}
                defaultValue={content.text}
                onChange={(e) => {
                  editConversation.value = e.target.value;
                  setEditConversation(editConversation);
                }}
              ></TextArea>
              <span style={{ position: 'absolute', right: 0, bottom: 0 }}>
                <Button
                  color="primary"
                  type="link"
                  onClick={() => {
                    let chatHistories = [];
                    const chatContent = localStorage.getItem('chatContent_' + chatId);
                    if (chatContent) {
                      chatHistories = JSON.parse(chatContent);
                    }
                    let editNumber = chatHistories.findIndex((c) => {
                      return c.role === 'user' && c.chat === content.text;
                    });
                    chatHistories.splice(editNumber);
                    localStorage.setItem('chatContent_' + chatId, JSON.stringify(chatHistories));
                    setChatList(chatHistories);
                    setEditBubble({});
                    setTimeout(() => handleSend('text', editConversation.value), 500);
                  }}
                >
                  OK
                </Button>
                <Button
                  color="primary"
                  type="link"
                  onClick={() => {
                    setEditBubble({});
                  }}
                >
                  Cancel
                </Button>
              </span>
            </div>
          )}
        </>
      );
    } else {
      return <Bubble style={{ width: type === 'feedback' ? '100%' : 'auto' }} content={<span>{content.text}</span>} />;
    }
  };

  const onFinish = async () => {
    try {
      const values = await form.validateFields();
      handleSend('text', values.messages);
      setTimeout(() => {
        form.resetFields();
      }, 100);
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === 'Enter' && event.shiftKey) {
      event.preventDefault(); // 防止默认行为
      form.submit(); // 提交表单
    }
  };

  const CustomComposer = (props: any) => {
    return (
      <div style={{ margin: 6 }}>
        <Checkbox.Group
          key={chatId}
          style={{ width: '100%', padding: 10, zIndex: 999, background: '#fff' }}
          options={roleList.map((item) => {
            return { label: item, value: item };
          })}
          value={checkedRoleList}
          onChange={(checkedValue) => {
            setCheckedRoleList(checkedValue);
          }}
        />
        <Form form={form} onFinish={onFinish} layout="inline">
          <Form.Item name="messages" style={{ width: 'calc(100% - 100px)' }}>
            <Mentions
              ref={mentionsRef}
              onSelect={(option, prefix) => {}}
              onChange={(text) => {}}
              split={''}
              name={'mentions'}
              autoSize={true}
              placeholder="input @ to mention your AI Consultant, use Shift+Enter send message"
              options={roleList.map((item) => {
                return { label: item, value: item };
              })}
              onKeyDown={handleKeyDown}
            />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary">
              Send
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  };

  return (
    <div className="unlimited-chat-container">
      {chatId ? (
        <>
          <Checkbox.Group
            key={chatId}
            style={{ padding: 10, zIndex: 999, background: '#fff', position: 'absolute', bottom: 55, left: 8 }}
            options={roleList.map((item) => {
              return { label: item, value: item };
            })}
            value={checkedRoleList}
            onChange={(checkedValue) => {
              setCheckedRoleList(checkedValue);
            }}
          />
          <Chat
            ref={ref}
            locale="en-US"
            navbar={undefined}
            messages={messages}
            renderMessageContent={renderMessageContent}
            onSend={handleSend}
            placeholder={t('chatgpt.placeholder')}
            // Composer={CustomComposer}
          />
        </>
      ) : (
        <div className="loading-page" style={{ position: 'absolute', zIndex: 300 }}>
          <div style={{ position: 'relative', textAlign: 'center' }}>
            <img alt="logo" width={400} src={process.env.REACT_APP_DOMAIN + 'assets/empty-logo.png'} />
            {/* <div style={{ marginTop: 20 }}>description: this is xxx</div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnlimitedChatContainer;
